import { head } from 'lodash';

export const SET_IS_AUTHORISATION_EDIT = 'SET_IS_AUTHORISATION_EDIT';
export const SET_EDIT_MODE = 'SET_EDIT_MODE';
export const SET_MULTI_TRANSACTIONS = 'SET_MULTI_TRANSACTIONS';
export const SET_PAYMENT_TYPE = 'SET_PAYMENT_TYPE';
export const SELECTED_PAYMENT_ID = 'SELECTED_PAYMENT_ID';
export const SET_LCV = 'SET_LCV';
export const SET_ADD_MULTIPLE = 'SET_ADD_MULTIPLE';
export const ADDING_NEW_ROW = 'ADDING_NEW_ROW';
export const SET_GROUP_APPROVALS_STATUS = 'SET_GROUP_APPROVALS_STATUS';

export const setIsAuthorisationEdit = (isAuthorisationEdit) => ({
	type: SET_IS_AUTHORISATION_EDIT,
	isAuthorisationEdit,
	meta: {
		allowedDuringApiCall: true,
	},
});

export const setMultiTransactions = (multiTransactions) => ({
	type: SET_MULTI_TRANSACTIONS,
	multiTransactions,
	meta: {
		allowedDuringApiCall: true,
	},
});

export const setEditMode = (payments) => {
	const action = (editMode) => ({
		type: SET_EDIT_MODE,
		editMode,
		meta: {
			allowedDuringApiCall: true,
		},
	});

	if (payments.length > 1) {
		return action('batch');
	}

	if (head(payments).type === 'repeating') {
		return action('repeating');
	}

	return action('single');
};

export const setPaymentType = ({ paymentType }) => ({
	type: SET_PAYMENT_TYPE,
	paymentType,
	meta: {
		allowedDuringApiCall: true,
	},
});

export const setIsLCV = (isLCV) => ({
	type: SET_LCV,
	isLCV,
	meta: {
		allowedDuringApiCall: true,
	},
});

export const setCanAddMultiplePayees = (canAddMultiplePayees) => ({
	type: SET_ADD_MULTIPLE,
	canAddMultiplePayees,
	meta: {
		allowedDuringApiCall: true,
	},
});

export const setAddingNewRow = (isAddingNewRow) => ({
	type: ADDING_NEW_ROW,
	isAddingNewRow,
	meta: {
		allowedDuringApiCall: true,
	},
});

export const setGroupApprovalsStatus = (enabled) => ({
	type: SET_GROUP_APPROVALS_STATUS,
	enabled,
	meta: {
		allowedDuringApiCall: true,
	},
});
